import { createApp } from 'vue';
import HeicToAvifConverter from '../Components/HeicToAvifConverter.vue';

const root = document.getElementById('heic-to-avif-converter');
if (root) {
  createApp(HeicToAvifConverter).mount('#heic-to-avif-converter');
}
